import Vue from "vue";
import VueRouter from "vue-router";
import Media from "../components/media/Media.vue";
import CulturalAmbassador from "../components/CulturalAmbassador.vue";
import Events from "../components/Events.vue";
import Home from "../components/Home.vue";
import History from "../components/istoric/History.vue";
import MarinConstantin from "../components/marin-constantin/MarinConstantin.vue";
import Management from "../components/Management";
import Announcement from "../components/Announcement";
import P404 from "../components/P404";
import Contact from "../components/Contact";
import Shop from "../components/Shop";
import NewsDetails from "../components/news/NewsDetails";
import Localized from "../components/Localized";
import PublicInformation from "../components/public-information/PublicInformation";
import PublicInformationRoot from "../components/public-information/PublicInformationRoot";
import Career from "../components/public-information/Career";
import Leadership from "../components/public-information/Leadership";
import Setlists from "../components/Setlists";
import MadrigalForBabies from "../components/MadrigalForBabies";
import Tours from "../components/Tours";
import Cathedrals from "../components/Cathedrals";
import Team from "../components/Team";
import Sound from "../components/Sound";
import GDPR from "../components/public-information/GDPR.vue";

Vue.use(VueRouter);

let router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/:locale?",
      component: Localized,
      children: [
        {
          path: "",
          component: Home,
          name: "home",
          meta: {
            title: "Corul Naţional de Cameră „Madrigal – Marin Constantin”",
          },
        },
        {
          path: "informatii-publice",
          component: PublicInformation,
          title: "Informații Publice",
          children: [
            {
              path: "",
              name: "public-information",
              component: PublicInformationRoot,
            },
            {
              path: "cariera",
              name: "careers",
              component: Career,
            },
            {
              path: "anunturi",
              name: "announcements",
              component: Announcement,
            },
            {
              path: "conducerea",
              name: "leadership",
              component: Leadership,
            },
            {
              path: "gdpr",
              name: "gdpr",
              component: GDPR,
            },
          ],
        },
        {
          path: "despre-madrigal/istoric/",
          name: "history",
          component: History,
          meta: {
            title: "Istoric | Madrigal",
          },
        },
        {
          path: "despre-madrigal/istoric/:section",
          name: "history-section",
          component: History,
          meta: {
            title: "Istoric | Madrigal",
          },
        },
        {
          path: "despre-madrigal/anunturi",
          name: "announcements",
          component: Announcement,
          meta: {
            title: "Anunturi | Madrigal",
          },
        },
        {
          path: "despre-madrigal/marin-constantin/",
          name: "mc",
          component: MarinConstantin,
          meta: {
            title: "Marin Constantin | Madrigal",
          },
        },
        {
          path: "despre-madrigal/management/",
          name: "management",
          component: Management,
          meta: {
            title: "Management | Madrigal",
          },
        },
        {
          path: "despre-madrigal/ambasador-cultural",
          name: "cultural-ambassador",
          component: CulturalAmbassador,
          meta: {
            title: "Ambasador cultural | Madrigal",
          },
        },
        {
          path: "evenimente/:type",
          name: "events",
          component: Events,
          meta: {
            title: "Evenimente | Madrigal",
          },
        },
        {
          path: "programe-sala/",
          name: "setlists",
          component: Setlists,
          meta: {
            title: "Programe Sală | Madrigal",
          }
        },
        {
          path: "media/",
          name: "media",
          component: Media,
          meta: {
            title: "Media | Madrigal",
          },
        },
        {
          path: "contact/",
          name: "contact",
          component: Contact,
          meta: {
            title: "Media | Madrigal",
          },
        },
        {
          path: "media/:section",
          name: "media-section",
          component: Media,
          meta: {
            title: "Media | Madrigal",
          },
        },
        {
          path: "media/:section/:subsection",
          name: "media-subsection",
          component: Media,
          meta: {
            title: "Media | Madrigal",
          },
        },
        {
          path: "magazin",
          name: "shop",
          component: Shop,
          meta: {
            title: "Magazin | Madrigal",
          },
        },
        {
          path: "stiri/:slug",
          name: "news-details",
          component: NewsDetails,
          meta: {
            title: "Stiri | Madrigal",
          },
        },
        {
          path: "babies",
          name: "babies",
          component: MadrigalForBabies,
          meta: {
            title: "Madrigal for Babies | Madrigal",
          },
        },
        {
          path: "turnee",
          name: "turnee",
          component: Tours,
          meta: {
            title: "Turnee | Madrigal",
          },
        },
        {
          path: "catedrale",
          name: "catedrale",
          component: Cathedrals,
          meta: {
            title: "Catedrale | Madrigal",
          },
        },
        {
          path: "echipa",
          name: "echipa",
          component: Team,
          meta: {
            title: "Echipa | Madrigal",
          },
        },
        {
          path: "sound",
          name: "sound",
          component: Sound,
          meta: {
            title: "Sound | Madrigal",
          },
        },
        {
          path: "*",
          name: "404",
          component: P404,
          meta: {
            title: "Pagina nu a fost gasită | Madrigal",
          },
        },
      ],
    },
  ],
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
